import React, { useState } from "react";
// node.js library that concatenates classes (strings)
import classnames from "classnames";
import { CommonLoading } from 'react-loadingg';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EVOControlsHelper from "../../../common/EVOControlsHelper";
import ReactTooltip from 'react-tooltip';
import { ValidatorHelper } from "../../../common/ValidatorHelper"
import {
    Button,
    Collapse,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    CardFooter,
    NavItem,
    NavLink,
    Nav,
    Progress,
    Table,
    Label,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col
} from "reactstrap";

import InstanceHeader from "components/Headers/InstanceHeader.js";
import GenericHeader from "components/Headers/GenericHeader.js";
import Accordion from 'react-bootstrap/Accordion';
import Moment from "moment";
import 'moment/locale/el';

import { Cascader } from 'antd';

function importAll(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
}

const images_tooltips_images = importAll(require.context('../tooltipimages/', false, /\.(png|jpe?g|svg)$/));

const WORKFLOW_IDS = {
    gasMaintainer: '98ea1b9e-b0c3-4166-b390-d95ce7f6fd18',
    gasSupplier: '000cbd3b-4e8e-42aa-a30b-ac2a7672cc6d',
    gasBoth: '390f156d-f0b1-43fa-b2a7-5ee4c658fd8c',
    electricityMaintainer: 'fbc2cb7f-eb1c-455f-a484-579ffb53f1a3',
    electricitySupplier: 'afe2dd96-b2bd-4af2-aace-4f53ada663cf',
    electricityBoth: '22c1e5ab-14eb-4334-b532-6456aa4bdbab',
    electricityAndGasSupplier: '58bf4d53-51cf-4135-9615-090be3c0c9d5'
};

class newInstance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            deddieElevenDigits: false,
            user: [],
            error: null,
            activeNav: 1,
            enabled: true,
            gasMaintainers: [],
            electrMaintainers: [],
            gasSuppliers: [],
            electrSuppliers: [],
            gasAndElectrSuppliers: [],
            selectedType: 0,
            selectedReceiver: 0,
            SupplierStr: '',
            SupplierStr2: '',
            wId: '',
            dropdownsActive: 1,
            instanceId: '',
            steps: [],
            files: [],
            fileUpload: null,
            instance: '',
            showModal: false,
            showSecondModal: false,
            serialNo: null,
            serialNo2: null,
            submittedInstancesSummary: [],
            instanceCategory: '',
            maintainerCategory: '',
            supplierCategory: '',
            isYesSelected: null,
            areAllFieldsFilled: false,
            isUploadingFiles: false,
            isSubmitting: false,
            uploadError: '',
            submissionError: '',
            responseDeadline: 10
        };

        this.changeType = this.changeType.bind(this);
        this.changeReceiver = this.changeReceiver.bind(this);
        this.changeSupplier = this.changeSupplier.bind(this);
        this.changeSupplier2 = this.changeSupplier2.bind(this);
        this.deleteFile = this.deleteFile.bind(this);

        this.updateInputValueCascader = this.updateInputValueCascader.bind(this);
    }

    async componentDidMount() {
        if (localStorage.getItem('token')) {
            fetch(process.env.REACT_APP_API_LINK + "/api/workflows/response_deadline/", {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'Content-Type': 'application/x-www-form-urlencoded'
                })
            })
                .then(res => res.json())
                .then((result) => {
                    this.setState({ responseDeadline: result.Duration || 10 });
                })
                .catch(() => {});
        }

        if (localStorage.getItem('token')) {
            fetch(process.env.REACT_APP_API_LINK + "/api/auth/user/", {
                method: 'get',
                headers: new Headers({
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'Content-Type': 'application/x-www-form-urlencoded'
                })
            })
                .then(res => res.json())
                .then(
                    (result) => {

                        this.setState({
                            isLoaded: true,
                            user: result,
                        });
                    },
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        };

        const result = await axios.get(process.env.REACT_APP_API_LINK + "/api/workflowinstances/lists/", {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
            .then(res => {
                this.setState({
                    gasMaintainers: res.data.gm,
                    electrMaintainers: res.data.em,
                    gasSuppliers: res.data.gs,
                    electrSuppliers: res.data.es,
                    gasAndElectrSuppliers: res.data.egs,
                    instanceId: uuidv4(),
                    instanceId2: uuidv4()
                });
            })
    };

    handleShowModal = () => {
        this.setState({ showModal: true });
    }

    handleJustCloseModal = () => {
        this.setState({ showModal: false });
    }

    handleShowSecondModal = () => {
        this.setState({ showSecondModal: true });
    }

    getConsumerDisplayName() {
        const user = this.state.user || {};
        const fullName = [user.Name, user.LastName].filter(Boolean).join(' ').trim();

        return fullName || user.Email || 'καταναλωτή';
    }

    handleJustCloseSecondModal = () => {
        this.setState({ showSecondModal: false });
        window.location.replace("/consumer/instance/" + this.state.instanceId);
    }

    getWorkflowIdForReceiver(selectedType, receiverKind) {
        if (selectedType == 1 && receiverKind == 1) {
            return WORKFLOW_IDS.gasMaintainer;
        }
        if (selectedType == 1 && receiverKind == 2) {
            return WORKFLOW_IDS.gasSupplier;
        }
        if (selectedType == 1 && receiverKind == 3) {
            return WORKFLOW_IDS.gasBoth;
        }
        if (selectedType == 2 && receiverKind == 1) {
            return WORKFLOW_IDS.electricityMaintainer;
        }
        if (selectedType == 2 && receiverKind == 2) {
            return WORKFLOW_IDS.electricitySupplier;
        }
        if (selectedType == 2 && receiverKind == 3) {
            return WORKFLOW_IDS.electricityBoth;
        }
        if (selectedType == 3) {
            return WORKFLOW_IDS.electricityAndGasSupplier;
        }

        return '';
    }

    getDigitsOnly(value) {
        return (value || '').toString().replace(/\D/g, '');
    }

    isSupplyNumberAction(action) {
        return action && action.Name == 'Αριθμός Παροχής*';
    }

    isGasSupplyAction(action) {
        return action && action.Target == 'aeriolimit14';
    }

    isDualProductSupplyAction(action) {
        return this.state.selectedType == 3 && this.isSupplyNumberAction(action);
    }

    isElectricitySupplyNumber(value) {
        return /^\d{11}$/.test(value || '');
    }

    isGasSupplyNumber(value) {
        return /^\d{14,20}$/.test(value || '');
    }

    parseDualSupplyValue(value) {
        const text = (value || '').toString();
        const electricityMatch = text.match(/Ηλεκτρική Παροχή:\s*(\d*)/);
        const gasMatch = text.match(/Αριθμός ΗΚΑΣΠ:\s*(\d*)/);

        if (electricityMatch || gasMatch) {
            return {
                electricitySupplyNumber: electricityMatch ? electricityMatch[1] : '',
                gasSupplyNumber: gasMatch ? gasMatch[1] : ''
            };
        }

        const digitGroups = text.match(/\d+/g) || [];
        if (digitGroups.length >= 2) {
            return {
                electricitySupplyNumber: digitGroups[0],
                gasSupplyNumber: digitGroups[1]
            };
        }

        const digits = this.getDigitsOnly(text);
        if (this.isElectricitySupplyNumber(digits)) {
            return { electricitySupplyNumber: digits, gasSupplyNumber: '' };
        }
        if (this.isGasSupplyNumber(digits)) {
            return { electricitySupplyNumber: '', gasSupplyNumber: digits };
        }

        return {
            electricitySupplyNumber: digits.length <= 11 ? digits : '',
            gasSupplyNumber: digits.length > 11 ? digits : ''
        };
    }

    formatDualSupplyValue(electricitySupplyNumber, gasSupplyNumber) {
        if (electricitySupplyNumber && !gasSupplyNumber) {
            return electricitySupplyNumber;
        }
        if (gasSupplyNumber && !electricitySupplyNumber) {
            return gasSupplyNumber;
        }

        const parts = [];
        if (electricitySupplyNumber) {
            parts.push('Ηλεκτρική Παροχή: ' + electricitySupplyNumber);
        }
        if (gasSupplyNumber) {
            parts.push('Αριθμός ΗΚΑΣΠ: ' + gasSupplyNumber);
        }
        return parts.join(' | ');
    }

    isDualSupplyValueValid(value) {
        const parsed = this.parseDualSupplyValue(value);
        const hasElectricity = parsed.electricitySupplyNumber !== '';
        const hasGas = parsed.gasSupplyNumber !== '';

        return (hasElectricity || hasGas)
            && (!hasElectricity || this.isElectricitySupplyNumber(parsed.electricitySupplyNumber))
            && (!hasGas || this.isGasSupplyNumber(parsed.gasSupplyNumber));
    }

    isSupplyActionValueValid(action, value) {
        if (this.isDualProductSupplyAction(action)) {
            return this.isDualSupplyValueValid(value);
        }

        const digits = this.getDigitsOnly(value);
        if (this.state.selectedType == 2) {
            return this.isElectricitySupplyNumber(digits);
        }
        if (this.state.selectedType == 1 || this.isGasSupplyAction(action)) {
            return this.isGasSupplyNumber(digits);
        }

        return this.isElectricitySupplyNumber(digits) || this.isGasSupplyNumber(digits);
    }

    getSupplyHelpText(action) {
        if (this.isDualProductSupplyAction(action)) {
            return 'Συμπληρώστε τουλάχιστον τον αριθμό παροχής ηλεκτρικής ενέργειας με 11 ψηφία ή τον αριθμό ΗΚΑΣΠ φυσικού αερίου με 14-20 ψηφία.';
        }
        if (this.state.selectedType == 2) {
            return 'Παρακαλούμε συμπληρώστε ορθά το πεδίο του Αριθμού Παροχής με 11 ψηφία';
        }
        if (this.state.selectedType == 1 || this.isGasSupplyAction(action)) {
            return 'Παρακαλούμε συμπληρώστε ορθά το πεδίο του Αριθμού Παροχής/ΗΚΑΣΠ με 14-20 ψηφία';
        }

        return 'Παρακαλούμε συμπληρώστε ορθά το πεδίο του Αριθμού Παροχής';
    }

    getSupplyInputLimitType(action) {
        if (this.state.selectedType == 2) {
            return 'electricitylimit11';
        }
        if (this.state.selectedType == 1 || this.isGasSupplyAction(action)) {
            return 'aeriolimit20';
        }
        return action.Target;
    }

    limitSupplyInputValue(evt, action) {
        let maxLength = null;
        if (this.state.selectedType == 2) {
            maxLength = 11;
        }
        else if (this.state.selectedType == 1 || this.isGasSupplyAction(action)) {
            maxLength = 20;
        }
        else if (action.Target == 'limit14') {
            maxLength = 14;
        }

        if (maxLength && evt.target.value.length > maxLength) {
            evt.target.value = evt.target.value.substring(0, maxLength);
        }
    }

    escapeHtml(value) {
        return (value || '').toString().replace(/[&<>"']/g, char => ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        }[char]));
    }

    setSupplyNumberTooltipImage(imageName) {
        const tooltipElement = document.getElementById("imageattooltip");
        if (!tooltipElement) {
            return;
        }

        const normalizedImageName = (imageName || '').toString().trim();
        if (normalizedImageName && images_tooltips_images[normalizedImageName]) {
            tooltipElement.innerHTML = "<img src=" + images_tooltips_images[normalizedImageName].default + " style='width:400px;max-width:100%;' alt='Υπόδειγμα λογαριασμού'/>";
            return;
        }

        if (normalizedImageName && normalizedImageName != 'NoImageAvaillable') {
            tooltipElement.innerHTML = "<div style='width:400px;max-width:100%;padding:12px;border:1px solid #ddd;background:#fff;color:#525f7f;'>Δεν υπάρχει διαθέσιμο υπόδειγμα λογαριασμού για αυτόν τον προμηθευτή.<br/>Αναμενόμενο αρχείο: src/views/examples/tooltipimages/" + this.escapeHtml(normalizedImageName) + "</div>";
            return;
        }

        tooltipElement.innerHTML = "";
    }

    getEnergyKindLabel(selectedType) {
        if (selectedType == 1) {
            return 'Φυσικό Αέριο';
        }
        if (selectedType == 2) {
            return 'Ηλεκτρική Ενέργεια';
        }
        if (selectedType == 3) {
            return 'Ηλεκτρική Ενέργεια & Φυσικό Αέριο';
        }

        return '';
    }

    getReceiverKindLabel(receiverKind) {
        if (receiverKind == 1) {
            return 'Διαχειριστής Δικτύου';
        }
        if (receiverKind == 2) {
            return 'Προμηθευτής Ενέργειας';
        }
        if (receiverKind == 3) {
            return 'Διαχειριστής Δικτύου και Προμηθευτής Ενέργειας';
        }

        return '';
    }

    getActionValueForParallelSubmission(actionOrder, sourceActionsByOrder, receiverKind, receiverName, category) {
        if (actionOrder == 5) {
            return this.getEnergyKindLabel(this.state.selectedType);
        }
        if (actionOrder == 6) {
            return this.getReceiverKindLabel(receiverKind);
        }
        if (actionOrder == 7) {
            return receiverName;
        }
        if (actionOrder == 8) {
            return category;
        }

        const sourceAction = sourceActionsByOrder[actionOrder];
        return sourceAction && sourceAction.data ? sourceAction.data.Data : '';
    }

    buildParallelSubmitStep(targetSteps, sourceStep, receiverKind, receiverName, category) {
        const targetStep = targetSteps.find(step => step.step.Status == sourceStep.step.Status) || targetSteps[0];
        const sourceActionsByOrder = {};

        sourceStep.actions.forEach(item => {
            sourceActionsByOrder[item.action.Order] = item;
        });

        return {
            ...targetStep,
            actions: targetStep.actions.map(item => ({
                ...item,
                data: {
                    ...item.data,
                    Data: this.getActionValueForParallelSubmission(
                        item.action.Order,
                        sourceActionsByOrder,
                        receiverKind,
                        receiverName,
                        category
                    )
                }
            }))
        };
    }

    ensureFetchOk(response) {
        if (response.ok) {
            return response;
        }

        return response.text().then(text => {
            let message = text;
            try {
                const parsed = JSON.parse(text);
                message = parsed.detail || text;
            }
            catch {
            }

            throw new Error(message || 'Το αίτημα δεν ολοκληρώθηκε.');
        });
    }

    handleSubmitError(error, stepStatus) {
        const message = error && error.message ? error.message : 'Η υποβολή του αιτήματος απέτυχε. Ελέγξτε τα πεδία και δοκιμάστε ξανά.';
        const stepIndex = this.state.steps.findIndex(step => step.step.Status == stepStatus);

        this.setState({
            isSubmitting: false,
            submissionError: message
        }, () => {
            if (stepIndex > -1) {
                this.updateSubmitStateForStep(stepIndex, this.state.steps);
            }
            else {
                this.setSubmitButtonsEnabled(this.state.areAllFieldsFilled);
            }
        });
    }

    renderRequestError() {
        const message = this.state.submissionError || this.state.uploadError;
        if (!message) {
            return <></>;
        }

        return (
            <p style={{ color: '#d32f2f', marginBottom: '16px' }}>
                {message}
            </p>
        );
    }

    fetchInitializedSteps(workflowId) {
        return fetch(process.env.REACT_APP_API_LINK + "/api/workflowinstances/initiliaze/" + workflowId + "/", {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        })
            .then(res => this.ensureFetchOk(res))
            .then(res => res.json())
            .then(result => result.stepsInfused);
    }

    createWorkflowInstance(instanceId, workflowId, receiverKind, receiverName) {
        return fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/new/', {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }),
            body: JSON.stringify({
                'selectedType': this.state.selectedType,
                'selectedReceiver': receiverKind,
                'selectedSupplier': receiverName,
                'workflow': workflowId,
                'instanceId': instanceId,
                'supplyContract': this.state.isYesSelected,
                'durationWaiting': 0
            })
        })
            .then(res => this.ensureFetchOk(res))
            .then(res => res.json());
    }

    submitWorkflowStep(instanceId, submitStep) {
        return fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/submit/' + instanceId + '/', {
            method: 'POST',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
            }),
            body: JSON.stringify(submitStep)
        }).then(res => this.ensureFetchOk(res));
    }

    handleOptionChange = (event) => {
        const value = event.target.value;
        this.setState({
            isYesSelected: value === 'ΝΑΙ' ? true : (value === 'ΟΧΙ' ? false : null)
        }, () => {
            console.log(this.state.isYesSelected);
            this.setSubmitButtonsEnabled(true);
        });
    };

    changeType(event) {
        // console.log(event.target.value);
        this.setState({
            selectedType: event.target.value,
            instanceCategory: '',
            maintainerCategory: '',
            supplierCategory: '',
            submittedInstancesSummary: []
        });

        if (event.target.value == 3) {
            this.setState({ selectedReceiver: 2 });
        }

        if (event.target.value == 4) {
            this.state.submitButton = 1;
        }
        this.forceUpdate()

    }

    changeReceiver(event) {
        // console.log(event.target.value);
        this.setState({
            selectedReceiver: event.target.value,
            instanceCategory: '',
            maintainerCategory: '',
            supplierCategory: '',
            submittedInstancesSummary: []
        });
        console.log(this.state.selectedReceiver);
    }

    changeSupplier(event) {
        // console.log(event.target.value);
        this.setState({ SupplierStr: event.target.value });
        if (this.state.selectedReceiver == 3) {
            if (event.target.value != 0 && this.state.SupplierStr2 != 0) {
                this.state.submitButton = 1;
            }
            else {
                this.state.submitButton = 0;
            }
        } else {
            if (event.target.value != 0) {
                this.state.submitButton = 1;
            }
            else {
                this.state.submitButton = 0;
            }
        }
    }

    changeSupplier2(event) {
        // console.log(event.target.value);
        this.setState({ SupplierStr2: event.target.value });

        if (this.state.selectedReceiver == 3) {
            if (event.target.value != 0 && this.state.SupplierStr != 0) {
                this.state.submitButton = 1;
            }
            else {
                this.state.submitButton = 0;
            }
        } else {
            if (event.target.value != 0) {
                this.state.submitButton = 1;
            }
            else {
                this.state.submitButton = 0;
            }
        }
    }

    handleClick = stepStatus => {
        var wId = '';

        if (this.state.selectedType == 1) {
            if (this.state.selectedReceiver == 1) {
                // this.setState({ wId: '98ea1b9e-b0c3-4166-b390-d95ce7f6fd18' });
                wId = '98ea1b9e-b0c3-4166-b390-d95ce7f6fd18'
            }
            else if (this.state.selectedReceiver == 2) {
                // this.setState({ wId:  '000cbd3b-4e8e-42aa-a30b-ac2a7672cc6d'});
                wId = '000cbd3b-4e8e-42aa-a30b-ac2a7672cc6d'
            }
            else if (this.state.selectedReceiver == 3) {
                // this.setState({ wId:  '390f156d-f0b1-43fa-b2a7-5ee4c658fd8c'});
                wId = '390f156d-f0b1-43fa-b2a7-5ee4c658fd8c'
            }
        }
        else if (this.state.selectedType == 2) {
            if (this.state.selectedReceiver == 1) {
                // this.setState({ wId:  'fbc2cb7f-eb1c-455f-a484-579ffb53f1a3'});
                wId = 'fbc2cb7f-eb1c-455f-a484-579ffb53f1a3'
            }
            else if (this.state.selectedReceiver == 2) {
                // this.setState({ wId:  'afe2dd96-b2bd-4af2-aace-4f53ada663cf'});
                wId = 'afe2dd96-b2bd-4af2-aace-4f53ada663cf'
            }
            else if (this.state.selectedReceiver == 3) {
                // this.setState({ wId:  '22c1e5ab-14eb-4334-b532-6456aa4bdbab' });
                wId = '22c1e5ab-14eb-4334-b532-6456aa4bdbab'
            }
        }
        else if (this.state.selectedType == 3) {
            // this.setState({ wId:  '58bf4d53-51cf-4135-9615-090be3c0c9d5'});
            wId = '58bf4d53-51cf-4135-9615-090be3c0c9d5'
        }

        this.setState({ dropdownsActive: 0 });

        axios.get(process.env.REACT_APP_API_LINK + "/api/workflowinstances/initiliaze/" + wId + "/", {
            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        })
            .then(res => {
                this.setState({
                    steps: res.data.stepsInfused,
                    fileUpload: null,
                    wId: wId
                });

                fetch(process.env.REACT_APP_API_LINK + '/api/images/getimagebyworkflowid/', {
                    method: 'POST',
                    headers: new Headers({
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }),
                    body: JSON.stringify({
                        // 'WorkflowId': this.state.wId,
                        'Energy': this.state.selectedType,
                        'Receiver': this.state.SupplierStr
                    })
                })
                    .then(res => res.json())
                    .then(data => {
                        // console.log('image');
                        // console.log(data);
                        try {
                            this.setSupplyNumberTooltipImage(data);
                        }
                        catch {

                        }
                    })

                this.setSubmitButtonsEnabled(false);
                this.setState({ showModal: true })
            })
    }

    setSubmitButtonsEnabled(isEnabled) {
        //isEnabled = true; //bug fix 20221115 hot fix to enable button
        try {
            if (isEnabled && !this.state.isUploadingFiles && !this.state.isSubmitting) {
                if (this.state.SupplierStr !== 'ΔΕΔΔΗΕ Α.Ε.' && this.state.isYesSelected != null && this.state.areAllFieldsFilled == true) {
                    document.getElementById('submit-button-1').removeAttribute('disabled');
                    document.getElementById('submit-button-2').removeAttribute('disabled');
                }
                else if (this.state.SupplierStr == 'ΔΕΔΔΗΕ Α.Ε.' && this.state.areAllFieldsFilled == true) {
                    document.getElementById('submit-button-1').removeAttribute('disabled');
                    document.getElementById('submit-button-2').removeAttribute('disabled');
                }
            } else {
                document.getElementById('submit-button-1').setAttribute('disabled', '');
                document.getElementById('submit-button-2').setAttribute('disabled', '');
            }

        }
        catch (ex) {
            console.error(ex);
        }
    }

    isActionFilledForSubmit(item) {
        const value = item.data.Data || '';

        if (!item.action.Required) {
            return true;
        }

        if (this.isSupplyNumberAction(item.action)) {
            return this.isSupplyActionValueValid(item.action, value);
        }

        if (value === '') {
            return false;
        }

        if (item.action.Name == 'Όνομα Κατόχου Παροχής*') {
            return value.trim().length > 0;
        }

        if (item.action.Description == 'Αριθμός Παροχής') {
            return this.isSupplyActionValueValid(item.action, value);
        }

        if (item.action.Target == 'afmlimit9') {
            return ValidatorHelper.AFMValidator.IsValidAfm(value);
        }

        if (item.action.Target == 'aeriolimit14') {
            return this.isGasSupplyNumber(this.getDigitsOnly(value));
        }

        return true;
    }

    updateSubmitStateForStep(stepIndex, steps) {
        const checkRequired = steps[stepIndex].actions
            .slice(0, 9)
            .filter(element => element.action.Required);

        const blockingActions = checkRequired.filter(item => !this.isActionFilledForSubmit(item));
        const dualCategoryMissing = this.state.selectedReceiver == 3 && (!this.state.maintainerCategory || !this.state.supplierCategory);

        if (blockingActions.length === 0 && !dualCategoryMissing) {
            this.setState({ areAllFieldsFilled: true }, () => {
                this.setSubmitButtonsEnabled(true);
            });
        }
        else {
            console.warn('Submit disabled. Missing or invalid required fields:', blockingActions.map(item => ({
                name: item.action.Name,
                description: item.action.Description,
                target: item.action.Target,
                value: item.data.Data
            })));
            this.setState({ areAllFieldsFilled: false }, () => {
                this.setSubmitButtonsEnabled(false);
            });
        }
    }

    deleteInstance = stepStatus => {
        window.location.replace("/consumer/index");
    }


    deleteFile = (fileId, actionId) => {
        var self = this;
        if (localStorage.getItem('token')) {
            axios.delete(process.env.REACT_APP_API_LINK + '/api/files/' + fileId + "/", {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
                .then(res => {
                    axios.get(process.env.REACT_APP_API_LINK + "/api/files/initializestatus/" + this.state.instanceId + "/", {
                        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                    })
                        .then(res => {
                            const data = [...this.state.steps];
                            const stepIndex = data.findIndex(step =>
                                step.actions.some(action => action.action.Id == actionId)
                            );

                            if (stepIndex > -1 && !res.data.some(file => file.ActionId == actionId)) {
                                const actionIndex = data[stepIndex].actions.findIndex(action => action.action.Id == actionId);

                                if (actionIndex > -1) {
                                    const tempAction = { ...data[stepIndex].actions[actionIndex] };
                                    tempAction.data.Data = '';
                                    data[stepIndex].actions[actionIndex] = tempAction;
                                }
                            }

                            this.setState({
                                loading: false,
                                files: res.data,
                                steps: data
                            }, () => {
                                if (stepIndex > -1) {
                                    this.updateSubmitStateForStep(stepIndex, data);
                                }
                            });
                        })
                })
        }
    }

    uploadFile = (evt, actionid) => {
        if (!evt.target.files || !evt.target.files[0]) {
            return;
        }

        const formData = new FormData();
        const res = actionid.split("/");

        formData.append("files", evt.target.files[0]);
        this.setState({
            isUploadingFiles: true,
            uploadError: '',
            submissionError: ''
        }, () => {
            this.setSubmitButtonsEnabled(false);
        });

        const shouldDuplicate = [
            '22c1e5ab-14eb-4334-b532-6456aa4bdbab',
            '390f156d-f0b1-43fa-b2a7-5ee4c658fd8c'
        ].includes(this.state.wId); // use this.state.wId or pass it as parameter if not stored

        fetch(process.env.REACT_APP_FILEMANAGER_LINK, {
            method: 'POST',
            body: formData,
        })
            .then(response => this.ensureFetchOk(response))
            .then(response => response.json())
            .then(result => {
                const commonPayload = {
                    'Name': result[0].name,
                    'Path': result[0].path,
                    'Size': result[0].size,
                    'Type': result[0].type,
                    'StepId': res[0],
                    'ActionId': res[1],
                };

                const firstUpload = fetch(`${process.env.REACT_APP_API_LINK}/api/files/new/`, {
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        ...commonPayload,
                        'InstanceId': this.state.instanceId,
                    })
                }).then(response => this.ensureFetchOk(response));

                const secondUpload = shouldDuplicate
                    ? fetch(`${process.env.REACT_APP_API_LINK}/api/files/new/`, {
                        method: 'POST',
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            ...commonPayload,
                            'InstanceId': this.state.instanceId2,
                        })
                    }).then(response => this.ensureFetchOk(response))
                    : Promise.resolve();

                Promise.all([firstUpload, secondUpload])
                    .then(() => {
                        return axios.get(`${process.env.REACT_APP_API_LINK}/api/files/initializestatus/${this.state.instanceId}/`, {
                            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
                        });
                    })
                    .then(statusRes => {
                        const data = [...this.state.steps];
                        const stepIndex = data.findIndex(step => step.step.Id == res[0]);

                        if (stepIndex > -1) {
                            const actionIndex = data[stepIndex].actions.findIndex(action => action.action.Id == res[1]);

                            if (actionIndex > -1) {
                                const tempAction = { ...data[stepIndex].actions[actionIndex] };
                                tempAction.data.Data = result[0].path || result[0].name;
                                data[stepIndex].actions[actionIndex] = tempAction;
                            }
                        }

                        this.setState({
                            loading: false,
                            isUploadingFiles: false,
                            files: statusRes.data,
                            steps: data
                        }, () => {
                            if (stepIndex > -1) {
                                this.updateSubmitStateForStep(stepIndex, data);
                            }
                        });
                    });
            })
            .catch((error) => {
                console.error('Error:', error);
                const data = [...this.state.steps];
                const stepIndex = data.findIndex(step => step.step.Id == res[0]);

                this.setState({
                    loading: false,
                    isUploadingFiles: false,
                    uploadError: 'Η μεταφόρτωση του αρχείου απέτυχε. Δοκιμάστε ξανά ή συνεχίστε χωρίς το αρχείο, εφόσον το αίτημα είναι πλήρες.'
                }, () => {
                    if (stepIndex > -1) {
                        this.updateSubmitStateForStep(stepIndex, data);
                    }
                    else {
                        this.setSubmitButtonsEnabled(this.state.areAllFieldsFilled);
                    }
                });
            });
    };



    updateInputValue(evt) {
        console.log(this.state);
        var res = evt.target.id.split("/");
        let data = [...this.state.steps];

        var i;
        for (i = 0; i < (this.state.steps).length; i++) {
            if (this.state.steps[i].step.Id == res[0]) {
                var j;
                for (j = 0; j < (this.state.steps[i].actions).length; j++) {
                    if (this.state.steps[i].actions[j].action.Id == res[1]) {
                        let tempAction = { ...data[i].actions[j] };

                        tempAction.data.Data = evt.target.value;
                        data[i].actions[j] = tempAction;

                        this.setState({
                            steps: data
                        });
                    }
                }
                this.updateSubmitStateForStep(i, data);
            }
        }

    }

    updateInputValueNumber(evt, dynamicactions) {
        if (this.isSupplyNumberAction(dynamicactions.action)) {
            this.limitSupplyInputValue(evt, dynamicactions.action);
        }
        else if (dynamicactions.action.Target == 'limit14') {
            if ((evt.target.value).length > 14) {
                evt.target.value = evt.target.value.substring(0, evt.target.value.length - 1);
            }
        }

        if (dynamicactions.action.Target == 'limit9') {
            if ((evt.target.value).length > 9) {
                evt.target.value = evt.target.value.substring(0, evt.target.value.length - 1);
            }
        }

        if (dynamicactions.action.Target == 'afmlimit9') {
            ValidatorHelper.AFMValidator.OnUpdateInputValueValidation(evt);
        }
        if (dynamicactions.action.Target == 'aeriolimit14') {
            if ((evt.target.value).length > 20) {
                evt.target.value = evt.target.value.substring(0, 20);
            }

        }

        var res = evt.target.id.split("/");
        let data = [...this.state.steps];

        // console.log(res);

        var i;
        for (i = 0; i < (this.state.steps).length; i++) {
            if (this.state.steps[i].step.Id == res[0]) {
                var j;
                for (j = 0; j < (this.state.steps[i].actions).length; j++) {
                    if (this.state.steps[i].actions[j].action.Id == res[1]) {
                        let tempAction = { ...data[i].actions[j] };

                        tempAction.data.Data = evt.target.value;
                        data[i].actions[j] = tempAction;

                        this.setState({
                            steps: data
                        });
                    }
                }
                this.updateSubmitStateForStep(i, data);
            }
        }
    }

    updateDualSupplyValue(evt, stepId, actionId, supplyKind) {
        const maxLength = supplyKind == 'electricitySupplyNumber' ? 11 : 20;
        if (evt.target.value.length > maxLength) {
            evt.target.value = evt.target.value.substring(0, maxLength);
        }

        const data = [...this.state.steps];
        for (let i = 0; i < data.length; i++) {
            if (data[i].step.Id == stepId) {
                for (let j = 0; j < data[i].actions.length; j++) {
                    if (data[i].actions[j].action.Id == actionId) {
                        const tempAction = { ...data[i].actions[j] };
                        const current = this.parseDualSupplyValue(tempAction.data.Data);
                        const nextValue = this.getDigitsOnly(evt.target.value);
                        const next = {
                            ...current,
                            [supplyKind]: nextValue
                        };

                        tempAction.data.Data = this.formatDualSupplyValue(next.electricitySupplyNumber, next.gasSupplyNumber);
                        data[i].actions[j] = tempAction;

                        this.setState({
                            steps: data
                        });
                    }
                }
                this.updateSubmitStateForStep(i, data);
            }
        }
    }

    updateInputValueCascader(value, stepId, actionId) {
        let temp = value.join(' / ').trim();
        var i;

        this.setState({ instanceCategory: temp });
        // console.log(temp);

        let data = [...this.state.steps];
        for (i = 0; i < (this.state.steps).length; i++) {
            if (this.state.steps[i].step.Id == stepId) {
                var j;
                for (j = 0; j < (this.state.steps[i].actions).length; j++) {
                    if (this.state.steps[i].actions[j].action.Id == actionId) {
                        let tempAction = { ...data[i].actions[j] };

                        tempAction.data.Data = temp;
                        data[i].actions[j] = tempAction;

                        this.setState({
                            steps: data
                        });
                    }
                }
                this.updateSubmitStateForStep(i, data);
            }
        }
    }

    updateParallelCategory(value, stepId, actionId, receiverKind) {
        const category = value.join(' / ').trim();
        const nextMaintainerCategory = receiverKind == 1 ? category : this.state.maintainerCategory;
        const nextSupplierCategory = receiverKind == 2 ? category : this.state.supplierCategory;
        const combinedCategory = nextMaintainerCategory && nextSupplierCategory
            ? 'Διαχειριστής: ' + nextMaintainerCategory + ' | Προμηθευτής: ' + nextSupplierCategory
            : '';
        let data = [...this.state.steps];

        for (let i = 0; i < (this.state.steps).length; i++) {
            if (this.state.steps[i].step.Id == stepId) {
                for (let j = 0; j < (this.state.steps[i].actions).length; j++) {
                    if (this.state.steps[i].actions[j].action.Id == actionId) {
                        let tempAction = { ...data[i].actions[j] };

                        tempAction.data.Data = combinedCategory;
                        data[i].actions[j] = tempAction;
                    }
                }

                this.setState({
                    steps: data,
                    instanceCategory: combinedCategory,
                    maintainerCategory: nextMaintainerCategory,
                    supplierCategory: nextSupplierCategory
                }, () => {
                    this.updateSubmitStateForStep(i, data);
                });
            }
        }
    }

    submitInstance = stepStatus => {
        console.log(this.state.wId);

        if (localStorage.getItem('token')) {
            this.setState({
                isSubmitting: true,
                submissionError: '',
                uploadError: ''
            }, () => {
                this.setSubmitButtonsEnabled(false);
            });

            if (this.state.selectedReceiver == 3) {
                const maintainerWorkflowId = this.getWorkflowIdForReceiver(this.state.selectedType, 1);
                const supplierWorkflowId = this.getWorkflowIdForReceiver(this.state.selectedType, 2);
                const sourceStep = this.state.steps[stepStatus - 1];

                Promise.all([
                    this.fetchInitializedSteps(maintainerWorkflowId),
                    this.fetchInitializedSteps(supplierWorkflowId)
                ])
                    .then(([maintainerSteps, supplierSteps]) => {
                        const maintainerSubmitStep = this.buildParallelSubmitStep(maintainerSteps, sourceStep, 1, this.state.SupplierStr, this.state.maintainerCategory);
                        const supplierSubmitStep = this.buildParallelSubmitStep(supplierSteps, sourceStep, 2, this.state.SupplierStr2, this.state.supplierCategory);

                        return this.createWorkflowInstance(this.state.instanceId, maintainerWorkflowId, 1, this.state.SupplierStr)
                            .then(maintainerInstance => this.submitWorkflowStep(maintainerInstance.Id, maintainerSubmitStep)
                                .then(() => maintainerInstance))
                            .then(maintainerInstance => this.createWorkflowInstance(this.state.instanceId2, supplierWorkflowId, 2, this.state.SupplierStr2)
                                .then(supplierInstance => this.submitWorkflowStep(supplierInstance.Id, supplierSubmitStep)
                                    .then(() => ({ maintainerInstance, supplierInstance }))));
                    })
                    .then(({ maintainerInstance, supplierInstance }) => {
                        this.setState({
                            serialNo: maintainerInstance.SerialNo,
                            serialNo2: supplierInstance.SerialNo,
                            submittedInstancesSummary: [
                                {
                                    serialNo: maintainerInstance.SerialNo,
                                    receiver: this.state.SupplierStr,
                                    receiverKind: 'Διαχειριστής Δικτύου',
                                    category: this.state.maintainerCategory
                                },
                                {
                                    serialNo: supplierInstance.SerialNo,
                                    receiver: this.state.SupplierStr2,
                                    receiverKind: 'Προμηθευτής Ενέργειας',
                                    category: this.state.supplierCategory
                                }
                            ],
                            showSecondModal: true,
                            isSubmitting: false
                        });
                    })
                    .catch(error => {
                        this.handleSubmitError(error, stepStatus);
                    });
            }
            else {
                fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/new/', {
                    method: 'POST',
                    headers: new Headers({
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }),
                    body: JSON.stringify({
                        'selectedType': this.state.selectedType,
                        'selectedReceiver': this.state.selectedReceiver,
                        'selectedSupplier': this.state.SupplierStr,
                        'workflow': this.state.wId,
                        'instanceId': this.state.instanceId,
                        'supplyContract': this.state.isYesSelected,
                        'durationWaiting': 0
                    })
                })
                    .then(res => this.ensureFetchOk(res))
                    .then(res => res.json())
                    .then(data => {
                        this.setState({ serialNo: data.SerialNo });
                        return fetch(process.env.REACT_APP_API_LINK + '/api/workflowinstances/submit/' + data.Id + '/', {
                            method: 'POST',
                            headers: new Headers({
                                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                            }),
                            body: JSON.stringify(this.state.steps[stepStatus - 1])
                        })
                    })
                    .then(res => this.ensureFetchOk(res))
                    .then(data => {
                        this.setState({
                            showSecondModal: true,
                            isSubmitting: false
                        })
                    })
                    .catch(error => {
                        this.handleSubmitError(error, stepStatus);
                    });
            }
        }
    }

    // GetImageByWorkflowId = (instanceid) => {
    //     fetch(process.env.REACT_APP_API_LINK + '/api/images/getimagebyworkflowid/' + this.state.wId + '/', {
    //         method: 'GET',
    //         headers: new Headers({
    //             'Authorization': 'Bearer ' + localStorage.getItem('token'),
    //         })
    //         // body: JSON.stringify({
    //         //   'fromdate': '2018-05-05',
    //         //   'todate': '2022-05-05'
    //         // })
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             alert(data);
    //             // console.log(data);
    //             document.getElementById("imageattooltip").innerHTML = "<img src=" + images_tooltips_images[data].default + " style='width:400px;' alt='Image'/>"
    //             // this.setState({
    //             //     data_statsbyenergykind: data
    //             // })
    //         })
    // }

    render() {
        const { showModal } = this.state;
        return (
            <>{this.state.SupplierStr != 'ΔΕΔΔΗΕ Α.Ε.' ?
                <>
                    <Modal isOpen={this.state.showModal} toggle={this.handleJustCloseModal} className="modal-90w" fade={false}>
                        <ModalHeader toggle={this.handleJustCloseModal}></ModalHeader>
                        <ModalBody>
                            <div>
                                <p>
                                    Αγαπητέ καταναλωτή, αν έχετε λάβει τη Σύμβαση Προμήθειας, παρακαλούμε πατήστε το κουμπί "ΝΑΙ" και στη συνέχεια επισυνάψτε τη Σύμβαση Προμήθειας στα επισυναπτόμενα έγγραφα, ειδάλλως παρακαλούμε πατήστε "ΌΧΙ".
                                    Σας εφιστούμε την προσοχή σχετικά με την απάντηση "ΟΧΙ", καθώς για τον αποτελεσματικότερο έλεγχο της υπόθεσή σας, στη συνέχεια θα ζητηθεί να προσκομισθεί η Σύμβαση Προμήθειας.
                                </p>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={this.handleJustCloseModal}>
                                Συνέχεια
                            </Button>
                        </ModalFooter>
                    </Modal>
                </> : <></>}
                <Modal isOpen={this.state.showSecondModal} toggle={this.handleJustCloseSecondModal} className="modal-90w" fade={false}>
                    <ModalHeader toggle={this.handleJustCloseSecondModal}></ModalHeader>
                    <ModalBody>
                        <div>
                            <p>
                                Αγαπητέ κύριε/κυρία {this.getConsumerDisplayName()}, αρχικά θα θέλαμε να σας ευχαριστήσουμε θερμά για την υποβολή της αναφοράς σας μέσω του My.Rae.gr. Θα θέλαμε να σας ενημερώσουμε πως η αναφορά σας υποβλήθηκε επιτυχώς
                                και έχει προωθηθεί προς τον αρμόδιο Παραλήπτη προς εξέταση. Για τη διευκόλυνσή σας, σας υπενθυμίζονται βασικές πληροφορίες της αναφοράς σας.
                            </p>
                            {this.state.submittedInstancesSummary.length > 0 ?
                                <>
                                    <p>
                                        Δημιουργήθηκαν δύο παράλληλες αναφορές, μία προς τον Διαχειριστή Δικτύου και μία προς τον Προμηθευτή Ενέργειας, με κοινά στοιχεία κατόχου και ξεχωριστή κατηγορία αιτήματος ανά παραλήπτη:
                                    </p>
                                    <ul>
                                        {this.state.submittedInstancesSummary.map(item =>
                                            <li>
                                                Α/Α: {item.serialNo} Παραλήπτης: {item.receiver} ({item.receiverKind}) Θέμα: {item.category}
                                            </li>
                                        )}
                                    </ul>
                                </>
                                :
                                <p>
                                    Α/Α: {this.state.serialNo} Παραλήπτης: {this.state.SupplierStr} Θέμα: {this.state.instanceCategory}
                                </p>
                            }
                            <p>
                                Τέλος σας υπενθυμίζουμε πως ο Παραλήπτης αναμένεται να απαντήσει εντός {this.state.responseDeadline} εργάσιμων ημερών από την υποβολή της αναφοράς σας.
                            </p>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleJustCloseSecondModal}>
                            Συνέχεια
                        </Button>
                    </ModalFooter>
                </Modal>
                <InstanceHeader />
                <div className="header pb-4" style={{ background: "linear-gradient(to right, #FFFFFF, #4A002B)" }}>
                    <Container fluid>
                        <div className="header-body">
                            <Row>
                                <Col lg="8" xl="12">
                                    <Card className="card-stats mb-4 mb-xl-0">
                                        <CardBody>
                                            <Row>
                                                <div className="col">
                                                    <CardTitle
                                                        tag="h5"
                                                        className="text-uppercase text-muted mb-0"
                                                    >
                                                    </CardTitle>
                                                    <span className="h4 font-weight-bold mb-0">
                                                        Υποβολή Νέου Αιτήματος - Παραπόνου
                                                    </span>
                                                </div>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>


                <Container className="mt-4" fluid>
                    {this.state.dropdownsActive == 1 ?
                        <Row className="mt-5">
                            <Col className="order-xl-1" xl="12">
                                <Card className="bg-secondary shadow">
                                    <CardHeader className="bg-white border-0">
                                        <Row className="align-items-center">
                                            <Col xs="8">
                                                Υποβολή Νέου Αιτήματος - Παραπόνου
                                            </Col>
                                            <Col className="text-right" xs="4">
                                                {this.state.submitButton == 1 ?
                                                    <Button
                                                        color="success"
                                                        onClick={() => { this.handleClick() }}
                                                        size="sm"
                                                    >
                                                        Συνέχεια <i className="fas fa-chevron-right" />
                                                    </Button> :
                                                    <p></p>
                                                }
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Form>
                                            <div className="pl-lg-4">
                                                <Row>
                                                    <Col lg="6">
                                                        <FormGroup>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="consumer-client"
                                                            >
                                                                Κατηγορία αιτήματος
                                                            </label>
                                                            &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-katigoria-aitimatos'} aria-hidden="true"></i>
                                                            <Input
                                                                className="form-control-alternative"
                                                                id="consumer-client"
                                                                type="select"
                                                                onChange={this.changeType}
                                                            >
                                                                <option value='0'>-- Επιλέξτε κατηγορία αιτήματος --</option>
                                                                <option value='1'>Φυσικό Αέριο</option>
                                                                <option value='2'>Ηλεκτρική Ενέργεια</option>
                                                                <option value='3'>Ηλεκτρική Ενέργεια και Φυσικό Αέριο</option>
                                                            </Input>
                                                            <ReactTooltip id={'info-katigoria-aitimatos'} type='info'>
                                                                <span>Επιλέξτε κατηγορία αιτήματος</span>
                                                            </ReactTooltip>
                                                        </FormGroup>
                                                    </Col>

                                                    {this.state.selectedType == 3 ?
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="consumer-user-home"
                                                                >
                                                                    Κατηγορία Παραλήπτη Αιτήματος
                                                                </label>
                                                                &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-paraliptis-aitimatos'} aria-hidden="true"></i>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    id="consumer-user-home"
                                                                    placeholder="Προμηθευτής Ενέργειας"
                                                                    type="text"
                                                                    disabled={true}
                                                                />
                                                                <ReactTooltip id={'info-paraliptis-aitimatos'} type='info'>
                                                                    <span>Επιλέξτε αν θέλετε να απευθυνθείτε <br />σε διαχειριστή ή προμηθευτή. <br />Εάν στο προηγούμενο πεδίο <br />έχετε επιλέξει αίτημα που αφορά <br />σε "Ηλεκτρική Ενέργεια και Φυσικό Αέριο", <br />τότε το παρόν πεδίο θα κλειδώσει <br />στην επιλογή "Προμηθευτής Ενέργειας".</span>
                                                                </ReactTooltip>
                                                            </FormGroup>
                                                        </Col>
                                                        :
                                                        <Col lg="6">
                                                            <FormGroup>
                                                                <label
                                                                    className="form-control-label"
                                                                    htmlFor="consumer-user-home"
                                                                >
                                                                    Κατηγορία Παραλήπτη Αιτήματος
                                                                </label>
                                                                &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-paraliptis-aitimatos'} aria-hidden="true"></i>
                                                                <Input
                                                                    className="form-control-alternative"
                                                                    id="consumer-user-home"
                                                                    type="select"
                                                                    onChange={this.changeReceiver}
                                                                >
                                                                    <option value='0'>-- Επιλέξτε κατηγορία παραλήπτη --</option>
                                                                    <option value='1'>Διαχειριστής Δικτύου</option>
                                                                    <option value='2'>Προμηθευτής Ενέργειας</option>
                                                                    <option value='3'>Διαχειριστής Δικτύου και Προμηθευτής Ενέργειας</option>
                                                                </Input>
                                                                <ReactTooltip id={'info-paraliptis-aitimatos'} type='info'>
                                                                    <span>Επιλέξτε αν θέλετε να απευθυνθείτε <br />σε διαχειριστή, προμηθευτή ή παράλληλα και στους δύο. <br />Εάν στο προηγούμενο πεδίο <br />έχετε επιλέξει αίτημα που αφορά <br />σε "Ηλεκτρική Ενέργεια και Φυσικό Αέριο", <br />τότε το παρόν πεδίο θα κλειδώσει <br />στην επιλογή "Προμηθευτής Ενέργειας".</span>
                                                                </ReactTooltip>
                                                            </FormGroup>
                                                        </Col>}

                                                </Row>

                                                {this.state.selectedType == 1 && this.state.selectedReceiver == 1 ?
                                                    <>
                                                        <Row>
                                                            <Col lg="6">
                                                                <FormGroup>
                                                                    <label
                                                                        className="form-control-label"
                                                                        htmlFor="consumer-use-commercial"
                                                                    >
                                                                        Επιλογή διαχειριστή (Φυσικό Αέριο)
                                                                    </label>
                                                                    &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-use-commercial'} aria-hidden="true"></i>
                                                                    <Input
                                                                        className="form-control-alternative"
                                                                        defaultValue="Lucky"
                                                                        id="consumer-use-commercial"
                                                                        type="select"
                                                                        onChange={this.changeSupplier}
                                                                    >
                                                                        <option value='0'>-- Επιλέξτε διαχειριστή --</option>
                                                                        {this.state.user.Email.includes('@rae.gr') ?
                                                                            <>
                                                                                {
                                                                                    this.state.gasMaintainers.map((dynamicData) =>
                                                                                        <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                    )}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    this.state.gasMaintainers.filter(dynamicData => dynamicData.Active !== false)
                                                                                        .map(dynamicData => (
                                                                                            <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                        ))}</>}

                                                                    </Input>
                                                                    <ReactTooltip id={'info-consumer-use-commercial'} type='info'>
                                                                        <span>Επιλέξτε διαχειριστή</span>
                                                                    </ReactTooltip>
                                                                </FormGroup>
                                                            </Col>

                                                            <div className="col-md-12" style={{ textAlign: 'center' }}>
                                                                <p>Με την υποβολή του αιτήματος, συμφωνείτε με τους <a href="https://www.rae.gr/myraeterms/">Όρους και τις Προϋποθέσεις</a></p>
                                                            </div>
                                                        </Row>
                                                    </>
                                                    : <> {this.state.selectedType == 1 && this.state.selectedReceiver == 2 ?
                                                        <>
                                                            <Row>
                                                                <Col lg="6">
                                                                    <FormGroup>
                                                                        <label
                                                                            className="form-control-label"
                                                                            htmlFor="consumer-user-home"
                                                                        >
                                                                            Επιλογή προμηθευτή (Φυσικό Αέριο)
                                                                        </label>
                                                                        &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-user-home-fysiko-aerio'} aria-hidden="true"></i>
                                                                        <Input
                                                                            className="form-control-alternative"
                                                                            id="consumer-user-home"
                                                                            type="select"
                                                                            onChange={this.changeSupplier}
                                                                        >
                                                                            <option value='0'>-- Επιλέξτε προμηθευτή --</option>
                                                                            {this.state.user.Email.includes('@rae.gr') ?
                                                                                <>
                                                                                    {
                                                                                        this.state.gasSuppliers.map((dynamicData) =>
                                                                                            <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                        )}
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {
                                                                                        this.state.gasSuppliers.filter(dynamicData => dynamicData.Active !== false)
                                                                                            .map(dynamicData => (
                                                                                                <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                            ))}</>}
                                                                        </Input>
                                                                        <ReactTooltip id={'info-consumer-user-home-fysiko-aerio'} type='info'>
                                                                            <span>Επιλέξτε προμηθευτή</span>
                                                                        </ReactTooltip>
                                                                    </FormGroup>
                                                                </Col>

                                                                <div className="col-md-12" style={{ textAlign: 'center' }}>
                                                                    <p>Με την υποβολή του αιτήματος, συμφωνείτε με τους <a href="https://www.rae.gr/myraeterms/">Όρους και τις Προϋποθέσεις</a></p>
                                                                </div>
                                                            </Row>
                                                        </> : <></>
                                                    }
                                                        {this.state.selectedType == 1 && this.state.selectedReceiver == 3 ?
                                                            <>
                                                                <Row>
                                                                    <Col lg="6">
                                                                        <FormGroup>
                                                                            <label
                                                                                className="form-control-label"
                                                                                htmlFor="consumer-use-commercial"
                                                                            >
                                                                                Επιλογή διαχειριστή (Φυσικό Αέριο)
                                                                            </label>
                                                                            &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-use-commercial'} aria-hidden="true"></i>
                                                                            <Input
                                                                                className="form-control-alternative"
                                                                                defaultValue="Lucky"
                                                                                id="consumer-use-commercial"
                                                                                type="select"
                                                                                onChange={this.changeSupplier}
                                                                            >
                                                                                <option value='0'>-- Επιλέξτε διαχειριστή --</option>
                                                                                {this.state.user.Email.includes('@rae.gr') ?
                                                                                    <>
                                                                                        {
                                                                                            this.state.gasMaintainers.map((dynamicData) =>
                                                                                                <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                            )}
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        {
                                                                                            this.state.gasMaintainers.filter(dynamicData => dynamicData.Active !== false)
                                                                                                .map(dynamicData => (
                                                                                                    <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                                ))}</>}
                                                                            </Input>
                                                                            <ReactTooltip id={'info-consumer-use-commercial'} type='info'>
                                                                                <span>Επιλέξτε διαχειριστή</span>
                                                                            </ReactTooltip>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col lg="6">
                                                                        <FormGroup>
                                                                            <label
                                                                                className="form-control-label"
                                                                                htmlFor="consumer-user-home"
                                                                            >
                                                                                Επιλογή προμηθευτή (Φυσικό Αέριο)
                                                                            </label>
                                                                            &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-user-home-fysiko-aerio'} aria-hidden="true"></i>
                                                                            <Input
                                                                                className="form-control-alternative"
                                                                                id="consumer-user-home"
                                                                                type="select"
                                                                                onChange={this.changeSupplier2}
                                                                            >
                                                                                <option value='0'>-- Επιλέξτε προμηθευτή --</option>
                                                                                {this.state.user.Email.includes('@rae.gr') ?
                                                                                    <>
                                                                                        {
                                                                                            this.state.gasSuppliers.map((dynamicData) =>
                                                                                                <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                            )}
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        {
                                                                                            this.state.gasSuppliers.filter(dynamicData => dynamicData.Active !== false)
                                                                                                .map(dynamicData => (
                                                                                                    <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                                ))}</>}
                                                                            </Input>
                                                                            <ReactTooltip id={'info-consumer-user-home-fysiko-aerio'} type='info'>
                                                                                <span>Επιλέξτε προμηθευτή</span>
                                                                            </ReactTooltip>
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <div className="col-md-12" style={{ textAlign: 'center' }}>
                                                                        <p>Με την υποβολή του αιτήματος, συμφωνείτε με τους <a href="https://www.rae.gr/myraeterms/">Όρους και τις Προϋποθέσεις</a></p>
                                                                    </div>
                                                                </Row>
                                                            </> : <></>}
                                                    </>
                                                }

                                                {this.state.selectedType == 2 && this.state.selectedReceiver == 1 ?
                                                    <>
                                                        <Row>
                                                            <Col lg="6">
                                                                <FormGroup>
                                                                    <label
                                                                        className="form-control-label"
                                                                        htmlFor="consumer-use-commercial"
                                                                    >
                                                                        Επιλογή διαχειριστή (Ηλεκτρική Ενέργεια)
                                                                    </label>
                                                                    &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-use-commercial-hlektrikh-diaxeiristis'} aria-hidden="true"></i>
                                                                    <Input
                                                                        className="form-control-alternative"
                                                                        defaultValue="Lucky"
                                                                        id="consumer-use-commercial"
                                                                        type="select"
                                                                        onChange={this.changeSupplier}
                                                                    >
                                                                        <option value='0'>-- Επιλέξτε διαχειριστή --</option>
                                                                        {this.state.user.Email.includes('@rae.gr') ?
                                                                            <>
                                                                                {
                                                                                    this.state.electrMaintainers.map((dynamicData) =>
                                                                                        <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                    )}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    this.state.electrMaintainers.filter(dynamicData => dynamicData.Active !== false)
                                                                                        .map(dynamicData => (
                                                                                            <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                        ))}</>}
                                                                    </Input>
                                                                    <ReactTooltip id={'info-consumer-use-commercial-hlektrikh-diaxeiristis'} type='info'>
                                                                        <span>Επιλέξτε διαχειριστή</span>
                                                                    </ReactTooltip>
                                                                </FormGroup>
                                                            </Col>

                                                            <div className="col-md-12" style={{ textAlign: 'center' }}>
                                                                <p>Με την υποβολή του αιτήματος, συμφωνείτε με τους <a href="https://www.rae.gr/myraeterms/">Όρους και τις Προϋποθέσεις</a></p>
                                                            </div>
                                                        </Row>
                                                    </>
                                                    : <> {this.state.selectedType == 2 && this.state.selectedReceiver == 2 ?
                                                        <>
                                                            <Row>
                                                                <Col lg="6">
                                                                    <FormGroup>
                                                                        <label
                                                                            className="form-control-label"
                                                                            htmlFor="consumer-user-home"
                                                                        >
                                                                            Επιλογή προμηθευτή (Ηλεκτρική Ενέργεια)
                                                                        </label>
                                                                        &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-user-home-hlektrikh-diaxeiristis'} aria-hidden="true"></i>
                                                                        <Input
                                                                            className="form-control-alternative"
                                                                            id="consumer-user-home"
                                                                            type="select"
                                                                            onChange={this.changeSupplier}
                                                                        >
                                                                            <option value='0'>-- Επιλέξτε προμηθευτή --</option>
                                                                            {this.state.user.Email.includes('@rae.gr') ?
                                                                                <>
                                                                                    {
                                                                                        this.state.electrSuppliers.map((dynamicData) =>
                                                                                            <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                        )}
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {
                                                                                        this.state.electrSuppliers.filter(dynamicData => dynamicData.Active !== false)
                                                                                            .map(dynamicData => (
                                                                                                <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                            ))}</>}
                                                                        </Input>
                                                                        <ReactTooltip id={'info-consumer-user-home-hlektrikh-diaxeiristis'} type='info'>
                                                                            <span>Επιλέξτε προμηθευτή</span>
                                                                        </ReactTooltip>
                                                                    </FormGroup>
                                                                </Col>

                                                                <div className="col-md-12" style={{ textAlign: 'center' }}>
                                                                    <p>Με την υποβολή του αιτήματος, συμφωνείτε με τους <a href="https://www.rae.gr/myraeterms/">Όρους και τις Προϋποθέσεις</a></p>
                                                                </div>
                                                            </Row>
                                                        </> : <></>
                                                    }
                                                        {this.state.selectedType == 2 && this.state.selectedReceiver == 3 ?
                                                            <>
                                                                <Row>
                                                                    <Col lg="6">
                                                                        <FormGroup>
                                                                            <label
                                                                                className="form-control-label"
                                                                                htmlFor="consumer-use-commercial"
                                                                            >
                                                                                Επιλογή διαχειριστή (Ηλεκτρική Ενέργεια)
                                                                            </label>
                                                                            &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-use-commercial-hlektrikh-diaxeiristis'} aria-hidden="true"></i>
                                                                            <Input
                                                                                className="form-control-alternative"
                                                                                defaultValue="Lucky"
                                                                                id="consumer-use-commercial"
                                                                                type="select"
                                                                                onChange={this.changeSupplier}
                                                                            >
                                                                                <option value='0'>-- Επιλέξτε διαχειριστή --</option>
                                                                                {this.state.user.Email.includes('@rae.gr') ?
                                                                                    <>
                                                                                        {
                                                                                            this.state.electrMaintainers.map((dynamicData) =>
                                                                                                <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                            )}
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        {
                                                                                            this.state.electrMaintainers.filter(dynamicData => dynamicData.Active !== false)
                                                                                                .map(dynamicData => (
                                                                                                    <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                                ))}</>}
                                                                            </Input>
                                                                            <ReactTooltip id={'info-consumer-use-commercial-hlektrikh-diaxeiristis'} type='info'>
                                                                                <span>Επιλέξτε διαχειριστή</span>
                                                                            </ReactTooltip>
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <Col lg="6">
                                                                        <FormGroup>
                                                                            <label
                                                                                className="form-control-label"
                                                                                htmlFor="consumer-user-home"
                                                                            >
                                                                                Επιλογή προμηθευτή (Ηλεκτρική Ενέργεια)
                                                                            </label>
                                                                            &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-user-home-hlektrikh-diaxeiristis'} aria-hidden="true"></i>
                                                                            <Input
                                                                                className="form-control-alternative"
                                                                                id="consumer-user-home"
                                                                                type="select"
                                                                                onChange={this.changeSupplier2}
                                                                            >
                                                                                <option value='0'>-- Επιλέξτε προμηθευτή --</option>
                                                                                {this.state.user.Email.includes('@rae.gr') ?
                                                                                    <>
                                                                                        {
                                                                                            this.state.electrSuppliers.map((dynamicData) =>
                                                                                                <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                            )}
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        {
                                                                                            this.state.electrSuppliers.filter(dynamicData => dynamicData.Active !== false)
                                                                                                .map(dynamicData => (
                                                                                                    <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                                ))}</>}
                                                                            </Input>
                                                                            <ReactTooltip id={'info-consumer-user-home-hlektrikh-diaxeiristis'} type='info'>
                                                                                <span>Επιλέξτε προμηθευτή</span>
                                                                            </ReactTooltip>
                                                                        </FormGroup>
                                                                    </Col>

                                                                    <div className="col-md-12" style={{ textAlign: 'center' }}>
                                                                        <p>Με την υποβολή του αιτήματος, συμφωνείτε με τους <a href="https://www.rae.gr/myraeterms/">Όρους και τις Προϋποθέσεις</a></p>
                                                                    </div>
                                                                </Row>
                                                            </> : <></>}
                                                    </>
                                                }

                                                {this.state.selectedType == 3 ?
                                                    <>
                                                        <Row>
                                                            <Col lg="6">
                                                                <FormGroup>
                                                                    <label
                                                                        className="form-control-label"
                                                                        htmlFor="consumer-user-home"
                                                                    >
                                                                        Επιλογή προμηθευτή (Ηλεκτρική Ενέργεια και Φυσικό Αέριο)
                                                                    </label>
                                                                    &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-consumer-user-home-fysiko-aerio'} aria-hidden="true"></i>
                                                                    <Input
                                                                        className="form-control-alternative"
                                                                        id="consumer-user-home"
                                                                        type="select"
                                                                        onChange={this.changeSupplier}
                                                                    >
                                                                        <option value='0'>-- Επιλέξτε προμηθευτή --</option>
                                                                        {this.state.user.Email.includes('@rae.gr') ?
                                                                            <>
                                                                                {
                                                                                    this.state.gasAndElectrSuppliers.map((dynamicData) =>
                                                                                        <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                    )}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {
                                                                                    this.state.gasAndElectrSuppliers.filter(dynamicData => dynamicData.Active !== false)
                                                                                        .map(dynamicData => (
                                                                                            <option value={dynamicData.Name}>{dynamicData.DisplayName || dynamicData.Name}</option>
                                                                                        ))}</>}
                                                                    </Input>
                                                                    <ReactTooltip id={'info-consumer-user-home-fysiko-aerio'} type='info'>
                                                                        <span>Επιλέξτε προμηθευτή</span>
                                                                    </ReactTooltip>
                                                                </FormGroup>
                                                            </Col>

                                                            <div className="col-md-12" style={{ textAlign: 'center' }}>
                                                                <p>Με την υποβολή του αιτήματος, συμφωνείτε με τους <a href="https://www.rae.gr/myraeterms/">Όρους και τις Προϋποθέσεις</a></p>
                                                            </div>
                                                        </Row>
                                                    </>
                                                    : <></>}
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        :
                        <>
                            {this.state.steps.map((dynamicData) =>
                                <>
                                    {dynamicData.step.Status == 1 ?
                                        <>
                                            {dynamicData.step.Conditional ?
                                                <Container className="mt-2" fluid>
                                                    <Row className="mt-5">
                                                        <Col className="order-xl-1" xl="12">
                                                            <Card className="bg-secondary shadow">
                                                                <CardHeader className="bg-white border-0">
                                                                    <Row className="align-items-center">
                                                                        <Col xs="8">
                                                                            <h3 className="mb-0">{dynamicData.step.Name}</h3>
                                                                        </Col>
                                                                        <Col className="text-right" xs="4">
                                                                            <Button
                                                                                color="danger"
                                                                                onClick={() => { this.deleteInstance() }}
                                                                                size="sm"
                                                                            >
                                                                                Ακύρωση
                                                                            </Button>
                                                                            <Button
                                                                                color="success"
                                                                                onClick={() => { this.submitInstance(dynamicData.step.Status) }}
                                                                                size="sm"
                                                                                id="submit-button-1"
                                                                            >
                                                                                Υποβολή
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </CardHeader>
                                                                <CardBody>
                                                                    {this.renderRequestError()}
                                                                    <Form>
                                                                        <div className="pl-lg-4">
                                                                            <Row>
                                                                                {dynamicData.actions.map((dynamicActions) =>
                                                                                    <>
                                                                                        {dynamicActions.action.RunTime == 'consumer' ?
                                                                                            <Col lg="12">
                                                                                                <FormGroup>
                                                                                                    <label
                                                                                                        className="form-control-label"
                                                                                                        htmlFor="input-username"
                                                                                                    >
                                                                                                        {dynamicActions.action.Name}
                                                                                                    </label>
                                                                                                    {/* </>} */}
                                                                                                    {dynamicActions.action.Type == 'file' ?
                                                                                                        <>
                                                                                                            <Row>
                                                                                                                <Col lg="10">
                                                                                                                    <label className="btn btn-primary" htmlFor={dynamicData.step.Id + "/" + dynamicActions.action.Id}>
                                                                                                                        Επιλογή αρχείου
                                                                                                                    </label>
                                                                                                                    &nbsp;
                                                                                                                    <i class="fa fa-info-circle" data-tip data-for={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} aria-hidden="true"></i>
                                                                                                                    <ReactTooltip id={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} type='info'>
                                                                                                                        <span>Μέγιστο μέγεθος αρχείου 5ΜΒ.</span>
                                                                                                                        <div id="imageattooltip"></div>
                                                                                                                    </ReactTooltip>
                                                                                                                    <Input
                                                                                                                        className="form-control-alternative"
                                                                                                                        // defaultValue={ dynamicActions.data.Data }
                                                                                                                        id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                                        // placeholder={dynamicActions.action.Description}
                                                                                                                        style={{ visibility: "hidden" }}
                                                                                                                        type={dynamicActions.action.Type}
                                                                                                                        disabled={!dynamicActions.action.Required}
                                                                                                                        onChange={evt => this.uploadFile(evt, dynamicData.step.Id + "/" + dynamicActions.action.Id)}
                                                                                                                    />
                                                                                                                </Col>
                                                                                                            </Row>

                                                                                                            <Table className="align-items-center table-flush" responsive>
                                                                                                                <thead className="thead-light">
                                                                                                                    <tr>
                                                                                                                        <th scope="col">Ονομα Αρχειου</th>
                                                                                                                        <th scope="col">Ημερομηνια Αναρτησης</th>
                                                                                                                        <th scope="col">Ενεργειες</th>
                                                                                                                    </tr>
                                                                                                                </thead>
                                                                                                                <tbody>
                                                                                                                    {
                                                                                                                        this.state.files.map((dynamicFiles) =>
                                                                                                                            <>
                                                                                                                                {dynamicActions.action.Id == dynamicFiles.ActionId ?
                                                                                                                                    <>
                                                                                                                                        <tr>
                                                                                                                                            <td>{dynamicFiles.FileName}</td>
                                                                                                                                            <td>{Moment(dynamicFiles.UploadDate).locale('el').format('dddd, DD MMM YYYY h:mm:ss a')}</td>
                                                                                                                                            <td>
                                                                                                                                                <Button
                                                                                                                                                    color="primary"
                                                                                                                                                    href={dynamicFiles.Link}
                                                                                                                                                    target="_blank"
                                                                                                                                                    size="sm"
                                                                                                                                                    title="Προβολή"
                                                                                                                                                >
                                                                                                                                                    <i className="fas fa-eye" />
                                                                                                                                                </Button>
                                                                                                                                                {console.log(dynamicFiles)}
                                                                                                                                                <Button
                                                                                                                                                    color="danger"
                                                                                                                                                    onClick={() => { this.deleteFile(dynamicFiles.Id, dynamicFiles.ActionId) }}
                                                                                                                                                    size="sm"
                                                                                                                                                    title="Διαγραφή"
                                                                                                                                                >
                                                                                                                                                    <i className="fas fa-trash" />
                                                                                                                                                </Button>
                                                                                                                                            </td>
                                                                                                                                        </tr>
                                                                                                                                    </> : <></>
                                                                                                                                }
                                                                                                                            </>
                                                                                                                        )}
                                                                                                                </tbody>
                                                                                                            </Table>
                                                                                                            <br />
                                                                                                            {this.state.SupplierStr != 'ΔΕΔΔΗΕ Α.Ε.' ?
                                                                                                                <>
                                                                                                                    <label htmlFor="yesNoSelect">Στα συνοδευτικά αρχεία μου περιέχεται και η ενεργή σύμβαση προμήθειας μου:</label>
                                                                                                                    <select
                                                                                                                        id="yesNoSelect"
                                                                                                                        value={this.state.isYesSelected === null ? '' : (this.state.isYesSelected ? 'ΝΑΙ' : 'ΟΧΙ')}
                                                                                                                        onChange={this.handleOptionChange}
                                                                                                                    >
                                                                                                                        <option value="" disabled>Επιλέξτε ΝΑΙ/ΟΧΙ</option>
                                                                                                                        <option value="ΟΧΙ">ΟΧΙ</option>
                                                                                                                        <option value="ΝΑΙ">ΝΑΙ</option>
                                                                                                                    </select>
                                                                                                                </> : <></>}
                                                                                                            {/* </> } */}
                                                                                                        </>
                                                                                                        : <>{dynamicActions.action.Type == 'button' ?
                                                                                                            <>
                                                                                                                <Col lg="6">
                                                                                                                    <Button
                                                                                                                        color="primary"
                                                                                                                        onClick={evt => this.dynamicCall(dynamicActions.action.Target)}
                                                                                                                        size="sm"
                                                                                                                    >
                                                                                                                        {dynamicActions.action.Description}
                                                                                                                    </Button>
                                                                                                                </Col>
                                                                                                            </>
                                                                                                            : <>{dynamicActions.action.Type == 'textarea' ?
                                                                                                                <React.Fragment>
                                                                                                                    &nbsp;<i class="fa fa-info-circle" data-tip data-for={'info-textarea' + dynamicData.step.Id + dynamicActions.action.Id} aria-hidden="true"></i>
                                                                                                                    <ReactTooltip id={'info-textarea' + dynamicData.step.Id + dynamicActions.action.Id} type='info'>
                                                                                                                        <span>{dynamicActions.action.Description}</span>
                                                                                                                    </ReactTooltip>
                                                                                                                    <Input
                                                                                                                        className="form-control-alternative"
                                                                                                                        defaultValue={dynamicActions.data.Data}
                                                                                                                        id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                                        placeholder={dynamicActions.action.Description}
                                                                                                                        type='textarea'
                                                                                                                        disabled={!dynamicActions.action.Required}
                                                                                                                        onChange={evt => this.updateInputValue(evt)}
                                                                                                                    />
                                                                                                                </React.Fragment>

                                                                                                                : <> {dynamicActions.action.Type == 'number' ?
                                                                                                                    <React.Fragment>
                                                                                                                        <i class="fa fa-info-circle" data-tip data-for={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} aria-hidden="true"></i>

                                                                                                                        {this.isDualProductSupplyAction(dynamicActions.action) ?
                                                                                                                            <>
                                                                                                                                <Row>
                                                                                                                                    <Col lg="6">
                                                                                                                                        <label className="form-control-label">Αριθμός Παροχής Ηλεκτρικής Ενέργειας</label>
                                                                                                                                        <EVOControlsHelper.InputInteger
                                                                                                                                            name={dynamicData.step.Id + "/" + dynamicActions.action.Id + "/electricity"}
                                                                                                                                            limitType="electricitylimit11"
                                                                                                                                            className="form-control-alternative"
                                                                                                                                            defaultValue={this.parseDualSupplyValue(dynamicActions.data.Data).electricitySupplyNumber}
                                                                                                                                            id={dynamicData.step.Id + "/" + dynamicActions.action.Id + "/electricity"}
                                                                                                                                            placeholder="11 ψηφία"
                                                                                                                                            type="text"
                                                                                                                                            disabled={!dynamicActions.action.Required}
                                                                                                                                            onChange={evt => this.updateDualSupplyValue(evt, dynamicData.step.Id, dynamicActions.action.Id, 'electricitySupplyNumber')}
                                                                                                                                        />
                                                                                                                                    </Col>
                                                                                                                                    <Col lg="6">
                                                                                                                                        <label className="form-control-label">Αριθμός ΗΚΑΣΠ / Παροχής Φυσικού Αερίου</label>
                                                                                                                                        <EVOControlsHelper.InputInteger
                                                                                                                                            name={dynamicData.step.Id + "/" + dynamicActions.action.Id + "/gas"}
                                                                                                                                            limitType="aeriolimit20"
                                                                                                                                            className="form-control-alternative"
                                                                                                                                            defaultValue={this.parseDualSupplyValue(dynamicActions.data.Data).gasSupplyNumber}
                                                                                                                                            id={dynamicData.step.Id + "/" + dynamicActions.action.Id + "/gas"}
                                                                                                                                            placeholder="14-20 ψηφία"
                                                                                                                                            type="text"
                                                                                                                                            disabled={!dynamicActions.action.Required}
                                                                                                                                            onChange={evt => this.updateDualSupplyValue(evt, dynamicData.step.Id, dynamicActions.action.Id, 'gasSupplyNumber')}
                                                                                                                                        />
                                                                                                                                    </Col>
                                                                                                                                </Row>
                                                                                                                                <CardBody>
                                                                                                                                    <p style={{ color: 'orange', marginLeft: '-20px', marginTop: '-20px', marginBottom: '-30px' }}><strong>{this.getSupplyHelpText(dynamicActions.action)}</strong></p>
                                                                                                                                </CardBody>
                                                                                                                            </>
                                                                                                                            :
                                                                                                                            <>
                                                                                                                                <EVOControlsHelper.InputInteger
                                                                                                                                    name={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                                                    limitType={this.getSupplyInputLimitType(dynamicActions.action)}
                                                                                                                                    className="form-control-alternative"
                                                                                                                                    defaultValue={dynamicActions.data.Data}
                                                                                                                                    id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                                                    placeholder={dynamicActions.action.Description}
                                                                                                                                    type={dynamicActions.action.Type}
                                                                                                                                    disabled={!dynamicActions.action.Required}
                                                                                                                                    onChange={evt => this.updateInputValueNumber(evt, dynamicActions)}
                                                                                                                                />
                                                                                                                                {this.isSupplyNumberAction(dynamicActions.action) ?
                                                                                                                                    <>
                                                                                                                                        <CardBody>
                                                                                                                                            <p style={{ color: 'orange', marginLeft: '-20px', marginTop: '-20px', marginBottom: '-30px' }}><strong>{this.getSupplyHelpText(dynamicActions.action)}</strong></p>
                                                                                                                                        </CardBody>
                                                                                                                                    </>
                                                                                                                                    : <></>}
                                                                                                                            </>}
                                                                                                                        {/* <Input
                                                                                                                            className="form-control-alternative"
                                                                                                                            defaultValue={dynamicActions.data.Data}
                                                                                                                            id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                                            placeholder={dynamicActions.action.Description}
                                                                                                                            type={dynamicActions.action.Type}
                                                                                                                            disabled={!dynamicActions.action.Required}
                                                                                                                            onChange={evt => this.updateInputValueNumber(evt, dynamicActions)}

                                                                                                                        /> */}

                                                                                                                        <ReactTooltip id={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} type='info'>
                                                                                                                            <span>{dynamicActions.action.Description}</span>
                                                                                                                            {dynamicActions.action.Description == 'Αριθμός Παροχής' ?
                                                                                                                                <>
                                                                                                                                    <div id="imageattooltip"></div>Συμπληρώστε τον αριθμό παροχής που φαίνεται στον λογαριασμό, χωρίς κενά και χωρίς παύλες.
                                                                                                                                </>
                                                                                                                                :
                                                                                                                                <>
                                                                                                                                </>

                                                                                                                            }

                                                                                                                        </ReactTooltip>

                                                                                                                    </React.Fragment>

                                                                                                                    : <> {dynamicActions.action.Type == 'dropdown' ?

                                                                                                                        <React.Fragment>
                                                                                                                            <i class="fa fa-info-circle" data-tip data-for={'info-dropdown' + dynamicData.step.Id + dynamicActions.action.Id} aria-hidden="true"></i>
                                                                                                                            <Row>
                                                                                                                                <Col lg="10">
                                                                                                                                    <ReactTooltip id={'info-dropdown' + dynamicData.step.Id + dynamicActions.action.Id} type='info'>
                                                                                                                                        <span>{dynamicActions.action.Description}</span>

                                                                                                                                        {/* <p>Δοκιμαστικό κείμενο</p> */}
                                                                                                                                    </ReactTooltip>
                                                                                                                                    {this.state.selectedReceiver == 3 && dynamicActions.action.Order == 8 ?
                                                                                                                                        <>
                                                                                                                                            <p style={{ color: '#525f7f', marginBottom: '12px' }}>
                                                                                                                                                Επιλέξτε κατηγορία αιτήματος για κάθε παραλήπτη.
                                                                                                                                            </p>
                                                                                                                                            <label className="form-control-label">Κατηγορία αιτήματος προς Διαχειριστή Δικτύου</label>
                                                                                                                                            <Cascader id={(dynamicData.step.Id + "/" + dynamicActions.action.Id + "/maintainer")} className={"dropdown"} options={JSON.parse(dynamicActions.action.Target)} onChange={value => this.updateParallelCategory(value, dynamicData.step.Id, dynamicActions.action.Id, 1)} placeholder={"Επιλέξτε κατηγορία για τον Διαχειριστή Δικτύου"} style={{ width: '100%', marginBottom: '12px' }} />
                                                                                                                                            <label className="form-control-label">Κατηγορία αιτήματος προς Προμηθευτή Ενέργειας</label>
                                                                                                                                            <Cascader id={(dynamicData.step.Id + "/" + dynamicActions.action.Id + "/supplier")} className={"dropdown"} options={JSON.parse(dynamicActions.action.Target)} onChange={value => this.updateParallelCategory(value, dynamicData.step.Id, dynamicActions.action.Id, 2)} placeholder={"Επιλέξτε κατηγορία για τον Προμηθευτή Ενέργειας"} style={{ width: '100%' }} />
                                                                                                                                        </>
                                                                                                                                        :
                                                                                                                                        <Cascader id={(dynamicData.step.Id + "/" + dynamicActions.action.Id)} className={"dropdown"} options={JSON.parse(dynamicActions.action.Target)} onChange={value => this.updateInputValueCascader(value, dynamicData.step.Id, dynamicActions.action.Id)} placeholder={"Επιλέξτε κατηγορία"} style={{ width: '100%' }} />
                                                                                                                                    }
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </React.Fragment>
                                                                                                                        :
                                                                                                                        <React.Fragment>
                                                                                                                            <i class="fa fa-info-circle" data-tip data-for={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} aria-hidden="true"></i>
                                                                                                                            <Input
                                                                                                                                className="form-control-alternative"
                                                                                                                                defaultValue={dynamicActions.data.Data}
                                                                                                                                id={dynamicData.step.Id + "/" + dynamicActions.action.Id}
                                                                                                                                placeholder={dynamicActions.action.Description}
                                                                                                                                type={dynamicActions.action.Type}
                                                                                                                                disabled={!dynamicActions.action.Required}
                                                                                                                                onChange={evt => this.updateInputValue(evt)}

                                                                                                                            />


                                                                                                                            <ReactTooltip id={'info-form-control-alternative' + dynamicData.step.Id + dynamicActions.action.Id} type='info'>
                                                                                                                                <span>{dynamicActions.action.Description}</span>

                                                                                                                                {/* <div id="imageattooltip"></div> */}
                                                                                                                            </ReactTooltip>

                                                                                                                        </React.Fragment>
                                                                                                                    }
                                                                                                                    </>
                                                                                                                }
                                                                                                                </>
                                                                                                            }
                                                                                                            </>
                                                                                                        }</>
                                                                                                    }
                                                                                                </FormGroup>
                                                                                            </Col>
                                                                                            :
                                                                                            <> </>
                                                                                        }
                                                                                    </>
                                                                                )}
                                                                            </Row>
                                                                        </div>
                                                                    </Form>
                                                                </CardBody>
                                                                <CardFooter className="bg-white border-0">
                                                                    <Row className="align-items-center">
                                                                        <Col xs="8">
                                                                            {/* <h3 className="mb-0">{dynamicData.step.Name}</h3> */}
                                                                        </Col>
                                                                        <Col className="text-right" xs="4">
                                                                            <Button
                                                                                color="danger"
                                                                                onClick={() => { this.deleteInstance() }}
                                                                                size="sm"
                                                                            >
                                                                                Ακύρωση
                                                                            </Button>
                                                                            <Button
                                                                                color="success"
                                                                                onClick={() => { this.submitInstance(dynamicData.step.Status) }}
                                                                                size="sm"
                                                                                id="submit-button-2"
                                                                            >
                                                                                Υποβολή
                                                                            </Button>
                                                                        </Col>
                                                                    </Row>
                                                                </CardFooter>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                                : <Container className="mt-2" fluid>
                                                    <Row className="mt-5">
                                                        <Col className="order-xl-1" xl="12">
                                                            <Card className="bg-secondary shadow">
                                                                <CardBody>
                                                                    <Form>
                                                                        <div className="pl-lg-4">
                                                                            <Row>
                                                                                <Col lg="12">
                                                                                    <p style={{ fontSize: '18px' }}>Θα ενημερωθείτε από τον Έλεγχο Πορείας για το επόμενο στάδιο της αίτησης που θα χρειαστεί να συμπληρώσετε.</p>
                                                                                    <Button
                                                                                        color="primary"
                                                                                        href={"/consumer/instance/" + this.state.instance.Id}
                                                                                        size="lg"
                                                                                    >
                                                                                        Έλεγχος πορείας
                                                                                    </Button>
                                                                                </Col>
                                                                            </Row>
                                                                        </div>
                                                                    </Form>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            }
                                        </>
                                        :
                                        <> </>
                                    }
                                </>
                            )}
                        </>
                    }
                </Container>
            </>
        );
    }
}

export default newInstance;

